import React from "react";
import { injectIntl } from "react-intl";
import Propertii from "../../common/Propertii";
import CreditReportingSubscriptionsReport from "../../common/ReportCreditReportingSubscriptions";

class ReportCreditReportingSubscriptions extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - The company complete transactions report component.
     */
    render() {

        return(
            <CreditReportingSubscriptionsReport companyId={this.props.match.params.companyId} userType='TYPE_ADMIN'/>
        )
    };
}

export default injectIntl(ReportCreditReportingSubscriptions);